"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var qs = __importStar(require("qs"));
var UrlParse = require("url-parse");
function getTrafficSource(userSpecific) {
    if (!userSpecific.gu) {
        return undefined;
    }
    var gu = JSON.parse(userSpecific.gu);
    var lastReferrer = userSpecific.lastReferrer;
    var data = {
        registeredPage: decodeURIComponent(gu.p || getPreviousHref() || getDocumentReferrer() || gu.lp || lastReferrer || ''),
        requestQuery: decodeURIComponent(gu.q || ''),
        requestReferrer: decodeURIComponent(gu.r),
        cookieCreationRegType: gu.rt,
    };
    var query = {};
    Object.assign(query, qs.parse(data.requestQuery, {
        ignoreQueryPrefix: true,
    }));
    if (data.requestReferrer) {
        query.referrer = data.requestReferrer;
    }
    data.requestQuery = "?" + qs.stringify(query, { arrayFormat: 'repeat' });
    return data;
}
exports.default = getTrafficSource;
// @todo from manageHistory
function getPreviousHref() {
    return null;
}
/**
 * Return window referrer in case
 * - Non client routing
 * - Last referrer from the same domain
 *
 * more info - PL-12166
 */
function getDocumentReferrer() {
    if (typeof window !== 'object') {
        return null;
    }
    var prefHref = getPreviousHref();
    /**
     * If we have prev href it means that user is using client routing
     */
    if (prefHref) {
        return null;
    }
    var referrerParsed = window.document.referrer ? UrlParse(window.document.referrer) : null;
    if (!referrerParsed) {
        return null;
    }
    var sameDomain = referrerParsed.origin === window.location.origin;
    // Only for same domain!
    if (sameDomain) {
        return window.document.referrer;
    }
    return null;
}
